import { defineStore } from "pinia";
import Services from '@/services/sutting/rolesServices'
import { mapRole } from '@/helpers/mapFuncs'

export const useRolesStore = defineStore("roles", {
persist: true,
state:()=>({
    role: {},
    roles: [],
}),
getters : {
    getRole() {
        return mapRole(this.role)
    },
    getRoles() {
        return this.roles.map(mapRole)
    },
},
actions : {
    /** Start Sets */
    setRole(role) {
        this.role = role
    },
    setRoles(roles) {
        this.roles = roles
    },
    /** End Sets */

    /** Start Actions */
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setRoles(response.data.data?.roles??[])
            return response
        })
    },
    /** End Actions */
}
});
